import styled from 'styled-components';

import Dialog from 'components/dialog';
import Picture from 'components/picture';

export const LoadingAnimationWrapper = styled.div`
  max-width: 170px;
  margin: 0 auto;
  margin-bottom: -1.8rem;
  padding: 1rem 1rem 0 1rem;
`;

export const SuccessAnimationWrapper = styled.div`
  z-index: ${Styles.zIndex.max - 100};
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const ImageContainer = styled(Picture)`
  max-width: 130px;
  margin: 1.5rem auto -1rem auto;
`;

export const ParagraphOptOut = styled.p`
  text-align: center;
  font-size: 1rem;
  a {
    color: ${Styles.color.primary};
  }
`;

export const OptInDialog = styled(Dialog)`
  max-height: 100vh;
  overflow-y: scroll;
`;

export const ActionWrapper = styled.div`
  margin: 1rem;
  min-width: auto;
  width: 100%;
`;
